module.exports = __webpack_public_path__ + "img/monmouthPark.4e70094a.png";